import { render, staticRenderFns } from "./CardTotals.vue?vue&type=template&id=be1c3250&"
import script from "./CardTotals.vue?vue&type=script&lang=js&"
export * from "./CardTotals.vue?vue&type=script&lang=js&"
import style0 from "./CardTotals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports